import html2canvas from 'html2canvas';
import { toast } from 'react-toastify';

const SCREENSHOT_CAPTURE_CLASS = 'dcf-table-screenshot-capture';
const SCREENSHOT_CAPTURE_STYLE_ID = 'dcf-table-screenshot-capture-style';

export function ensureScreenshotCaptureStyles() {
    if (typeof document === 'undefined' || document.getElementById(SCREENSHOT_CAPTURE_STYLE_ID)) {
        return;
    }
    const style = document.createElement('style');
    style.id = SCREENSHOT_CAPTURE_STYLE_ID;
    style.textContent =
        `.${SCREENSHOT_CAPTURE_CLASS} tfoot, ` +
        `.${SCREENSHOT_CAPTURE_CLASS} #copy-table-icon-button { display: none !important; }` +
        `.${SCREENSHOT_CAPTURE_CLASS} th { padding: 10px; font-size: 14px; line-height: 1.2; font-weight: 600; background-color: #f8f9fa; color: #000; }` +
        `.${SCREENSHOT_CAPTURE_CLASS} td { padding: 10px; font-size: 14px; line-height: 1.2; color: #000; }`;
    document.head.appendChild(style);
}

export async function copyElementAsImage(element) {
    if (!element) {
        toast.error('Could not find the table to copy.');
        return;
    }

    try {
        element.classList.add(SCREENSHOT_CAPTURE_CLASS);

        const canvas = await html2canvas(element, {
            scale: 2,
            backgroundColor: '#ffffff',
        });

        await new Promise((resolve, reject) => {
            canvas.toBlob(async (blob) => {
                if (!blob) {
                    reject(new Error('Failed to create blob from canvas'));
                    return;
                }
                try {
                    await navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })]);
                    toast.success('The table has been copied as an image.');
                    resolve();
                } catch (err) {
                    reject(err);
                }
            });
        });
    } catch (error) {
        console.error('Failed to copy table as image:', error);
        toast.error('Could not copy the table.');
    } finally {
        element.classList.remove(SCREENSHOT_CAPTURE_CLASS);
    }
}
